import * as React from "react";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { ExternalDocumentType } from "../../../../../../../Wrap/Models/Domains/Documents/ExternalDocumentType";
import { InstrumentSelection } from "../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { MultiDownloadButton } from "../../../../../../Shared/DownloadButton/MultiDownloadButton";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientAccountStore } from "../../../../../Stroes/Variable";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { AdviserContextStoreStatic } from "../../../NewBusinessWizard/Stores/Variable";
import { processTypeEnum } from "../../Resource/Contents";
import { SectionHeader } from "../../SharedComponents";

interface IInvestmentDocumentsProps extends IProcessComponentProps {
    data:
        | ApplyModel
        | GiaContributionModel
        | IsaContributionModel
        | PensionContributionModel
        | WrapCashContributionModel;
    selectAll: boolean;
    hideCheckBox?: boolean;
    triggerred: number;
    processType: processTypeEnum;
    subAccountType: SubAccountType;
    clAccountId?: string;
}

interface IInvestmentDocuments {}

export class InvestmentDocuments extends ProcessComponent<IInvestmentDocumentsProps, IInvestmentDocuments> {
    constructor(props: IInvestmentDocumentsProps) {
        super(props);
        this.state = {};
    }
    
    private hasRetirementAllocationExceptGBPCash(model: PensionBase): boolean {
        return model?.PreRetirementInstrumentSelections?.Instruments?.some((x) => x.Instrument.Name != "GBP Cash") || model?.PostRetirementInstrumentSelections?.Instruments?.some((x) => x.Instrument.Name != "GBP Cash");
   }

    private isDisabledInvestmentDocuments(): boolean {
        const wizardProcesType = this.props.processType;

        const nonInvestmentDocumentProducts: ProductType[] = [ProductType.Cash, ProductType.CashProduct];

        if (
            wizardProcesType == processTypeEnum.NewBusinessExistingClient ||
            wizardProcesType == processTypeEnum.NewQuoteExistingClient ||
            wizardProcesType == processTypeEnum.Quote ||
            wizardProcesType == processTypeEnum.NewBusiness
        ) {
            const applyModel: ApplyModel = this.props.data;
            if (
                applyModel.IsaModel.InstrumentSelections != null &&
                applyModel.IsaModel.InstrumentSelections.Instruments.length > 0
            ) {
                const isaInstruments = applyModel.IsaModel.InstrumentSelections.Instruments.filter(
                    (item: InstrumentSelection) => {
                        return !nonInvestmentDocumentProducts.includes(item.Instrument.Type);
                    }
                );
                if (isaInstruments.length > 0) {
                    return false;
                }
            }
            if (
                applyModel.GiaModel.InstrumentSelections != null &&
                applyModel.GiaModel.InstrumentSelections.Instruments.length > 0
            ) {
                const isaInstruments = applyModel.GiaModel.InstrumentSelections.Instruments.filter(
                    (item: InstrumentSelection) => {
                        return !nonInvestmentDocumentProducts.includes(item.Instrument.Type);
                    }
                );
                if (isaInstruments.length > 0) {
                    return false;
                }
            }
            if (
                applyModel.PensionApply.InstrumentSelections != null &&
                applyModel.PensionApply.InstrumentSelections.Instruments.length > 0
            ) {
                const isaInstruments = applyModel.PensionApply.InstrumentSelections.Instruments.filter(
                    (item: InstrumentSelection) => {
                        return !nonInvestmentDocumentProducts.includes(item.Instrument.Type);
                    }
                );
                if (isaInstruments.length > 0) {
                    return false;
                }
            }
            if (
                applyModel.PensionApply.PreRetirementInstrumentSelections != null &&
                applyModel.PensionApply.PreRetirementInstrumentSelections.Instruments.length > 0
            ) {
                const instruments = applyModel.PensionApply.PreRetirementInstrumentSelections.Instruments.filter(
                    (item: InstrumentSelection) => {
                        return !nonInvestmentDocumentProducts.includes(item.Instrument.Type);
                    }
                );
                if (instruments.length > 0) {
                    return false;
                }
            }
            if (
                applyModel.PensionApply.PostRetirementInstrumentSelections != null &&
                applyModel.PensionApply.PostRetirementInstrumentSelections.Instruments.length > 0
            ) {
                const instruments = applyModel.PensionApply.PostRetirementInstrumentSelections.Instruments.filter(
                    (item: InstrumentSelection) => {
                        return !nonInvestmentDocumentProducts.includes(item.Instrument.Type);
                    }
                );
                if (instruments.length > 0) {
                    return false;
                }
            }
            if (applyModel.IsaModel.IsaTransfers != null) {
                let hasIsaTransfer = false;
                applyModel.IsaModel.IsaTransfers.map((it, idx) => {
                    if (it.Instruments.length > 0) {
                        hasIsaTransfer = true;
                        return;
                    }
                });
                return !hasIsaTransfer;
            }
            if (applyModel.GiaModel.GiaTransfers != null) {
                let hasGiaTransfer = false;
                applyModel.GiaModel.GiaTransfers.map((it, idx) => {
                    if (it.Instruments.length > 0) {
                        hasGiaTransfer = true;
                        return;
                    }
                });

                return !hasGiaTransfer;
            }

            return true;
        } else if (
            wizardProcesType == processTypeEnum.SinglePaymentTransfer ||
            wizardProcesType == processTypeEnum.RegularPayment
        ) {
            if (SubAccountTypeHelper.isOnPlatformPension(this.props.subAccountType)) {
                const pensionContributionModel: PensionContributionModel = this.props.data;
                return this.hasRetirementAllocationExceptGBPCash((pensionContributionModel));
            }
            else{            
                const wrapCashContributionModel: WrapCashContributionModel = this.props.data;
                if (wrapCashContributionModel.Contribution.InstrumentSelections == null) {
                    return true;
                }
                const wrapCashInstruments = wrapCashContributionModel.Contribution.InstrumentSelections.Instruments.filter(
                    (item: InstrumentSelection, index) => {
                        return !nonInvestmentDocumentProducts.includes(item.Instrument.Type);
                    }
                );
                if (wrapCashInstruments.length > 0) {
                    return false;
                } else {
                    return true;
                }}

        } else {
            /**processTypeEnum.topUpWithITFLS,processTypeEnum.GadReview,processTypeEnum.TakePensionBenefits,processTypeEnum.EditIncomePayments, these four situation dont related to instrument) */
            return true;
        }
    }

    private isBuyingCashProducts(): boolean
    {
        const applyModelHasCashProducts: boolean = (this.props.data as ApplyModel)
                ?.GiaModel
                ?.InstrumentSelections
                ?.Instruments
                ?.some(x => x.Instrument.Type === ProductType.CashProduct)
            ?? false;

        const giaContributionModelHasCashProducts: boolean = (this.props.data as GiaContributionModel)
                ?.Contribution
                ?.InstrumentSelections
                ?.Instruments
                ?.some(x => x.Instrument.Type === ProductType.CashProduct)
            ?? false;

        return applyModelHasCashProducts || giaContributionModelHasCashProducts;
    }

    private showDocumentsToSend(): boolean {
        const process = this.props.processType;
        
        if(process == processTypeEnum.PPToISA || process == processTypeEnum.PPToSIPP){
            return false;
        }

        return true;
    }

    render() {
        const { processType } = this.props;
        const props = {
            triggerred: this.props.triggerred,
            isSelectedAll: this.props.selectAll,
        };
        const showInvestmentDocuments = !this.isDisabledInvestmentDocuments();
        const params = getQueryParameters();
        const customerid = params["customerid"];
        const claccountid = this.props.clAccountId;
        const applyModel: ApplyModel = this.props.data;
        const showCashProductDocuments: boolean = this.isBuyingCashProducts();

        let instructionId = params["id"];
        if (instructionId.toString().includes("-")) {
            instructionId = HierarchyIdHelper.generateHierarchyId(instructionId).entityId;
        }
        const company =
            ClientAccountStore.getClientAccountInfo()?.Company || AdviserContextStoreStatic.getData()?.Company;
        const headAccountHierarchyId = params["hierarchyid"];
        return ( this.showDocumentsToSend() &&
            <>
                {SectionHeader(
                    "Investment documents",
                    "KIID and fund factsheets are consolidated into one PDF.  These documents will also appear in your client’s document store."
                )}
                {showInvestmentDocuments && (
                    <MultiDownloadButton
                        fileName="Fund Fact Sheets"
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        request={DocumentsHelper.getTaskRequestFortInvestmentDocumentsInstruction(
                            instructionId,
                            customerid,
                            claccountid,
                            company,
                            ExternalDocumentType.FundFactSheets,
                            processType,
                            DocumentTaskRequestTypeEnum.ExternalFundDocument,
                            headAccountHierarchyId
                        )}
                        selectedAccount={headAccountHierarchyId}
                        hideCheckbox={this.props.hideCheckBox}
                    />
                )}
                {showInvestmentDocuments && (
                    <MultiDownloadButton
                        fileName="Investment Key Information Document"
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        request={DocumentsHelper.getTaskRequestFortInvestmentDocumentsInstruction(
                            instructionId,
                            customerid,
                            claccountid,
                            company,
                            ExternalDocumentType.KidDocuments,
                            processType,
                            DocumentTaskRequestTypeEnum.ExternalFundDocument,
                            headAccountHierarchyId
                        )}
                        selectedAccount={headAccountHierarchyId}
                        hideCheckbox={this.props.hideCheckBox}
                    />
                )}
                {showInvestmentDocuments && (
                    <MultiDownloadButton
                        fileName="KIID/Simplified Prospectus"
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        request={DocumentsHelper.getTaskRequestFortInvestmentDocumentsInstruction(
                            instructionId,
                            customerid,
                            claccountid,
                            company,
                            ExternalDocumentType.KiidDocuments,
                            processType,
                            DocumentTaskRequestTypeEnum.ExternalFundDocument,
                            headAccountHierarchyId
                        )}
                        selectedAccount={headAccountHierarchyId}
                        hideCheckbox={this.props.hideCheckBox}
                    />
                )}
                {showCashProductDocuments && (
                    <MultiDownloadButton
                        fileName="Cash Deposit Product Information Sheets"
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        request={DocumentsHelper.getTaskRequestFortInvestmentDocumentsInstruction(
                            instructionId,
                            customerid,
                            claccountid,
                            company,
                            ExternalDocumentType.SummaryBoxes,
                            processType,
                            DocumentTaskRequestTypeEnum.ExternalFundDocument,
                            headAccountHierarchyId
                        )}
                        selectedAccount={headAccountHierarchyId}
                    />
                )}
                {showCashProductDocuments && (
                    <MultiDownloadButton
                        fileName="FSCS Information Sheets"
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        request={DocumentsHelper.getTaskRequestFortInvestmentDocumentsInstruction(
                            instructionId,
                            customerid,
                            claccountid,
                            company,
                            ExternalDocumentType.FscsSheets,
                            processType,
                            DocumentTaskRequestTypeEnum.ExternalFundDocument,
                            headAccountHierarchyId
                        )}
                        selectedAccount={headAccountHierarchyId}
                    />
                )}
                {showCashProductDocuments && (
                    <MultiDownloadButton
                        fileName="Bondsmith Terms & Conditions"
                        {...props}
                        data={null}
                        onChange={() => {}}
                        onRef={(ref) => this.appendChild(ref)}
                        request={DocumentsHelper.getTaskRequestFortInvestmentDocumentsInstruction(
                            instructionId,
                            customerid,
                            claccountid,
                            company,
                            ExternalDocumentType.BondsmithTermsAndConditions,
                            processType,
                            DocumentTaskRequestTypeEnum.ExternalFundDocument,
                            headAccountHierarchyId
                        )}
                        selectedAccount={headAccountHierarchyId}
                    />
                )}
            </>
        );
    }
}
